"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FelaGrid = exports.ruleKeysFelaGrid = exports.FelaRuleGrid = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FelaCache_1 = require("../../fela/FelaCache");
const FelaRuleGrid = ({ basis, align, justify, alignItems, justifyItems, grow, shrink, overflow, zIndex, position = "relative", alignSelf, justifySelf, gridTemplateColumns, gridTemplateRows, gridAutoFlow, gridAutoColumns, gap, padding, margin, gridColumn = "", gridRow = "", top, bottom, left, right, }) => ({
    position,
    zIndex,
    display: "grid",
    overflow,
    flexBasis: basis,
    alignContent: align,
    justifyContent: justify,
    gridAutoFlow,
    flexGrow: grow,
    flexShrink: shrink,
    transition: "background 0.15s ease-out, box-shadow 0.15s ease-out, color 0.15s ease-out",
    alignSelf,
    justifySelf,
    gridTemplateColumns,
    gridTemplateRows,
    gridAutoColumns,
    gap,
    padding,
    margin,
    gridColumn,
    gridRow,
    alignItems,
    justifyItems,
    top,
    bottom,
    left,
    right,
});
exports.FelaRuleGrid = FelaRuleGrid;
exports.ruleKeysFelaGrid = [
    "basis",
    "align",
    "justify",
    "alignItems",
    "justifyItems",
    "grow",
    "shrink",
    "overflow",
    "zIndex",
    "position",
    "alignSelf",
    "justifySelf",
    "gridTemplateColumns",
    "gridTemplateRows",
    "gridAutoFlow",
    "gridAutoColumns",
    "gap",
    "padding",
    "margin",
    "gridColumn",
    "gridRow",
    "top",
    "bottom",
    "left",
    "right",
];
const FelaGrid = ({ children, cssExtra = [], className = "", rootProps, style, ...props }) => {
    // const { css } = useFela(props);
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    return ((0, jsx_runtime_1.jsx)("div", { style: style, className: `${className} ${cachedClass(exports.FelaRuleGrid, props, exports.ruleKeysFelaGrid)} ${inlineCss(cssExtra)}`, ...rootProps, children: children }));
};
exports.FelaGrid = FelaGrid;
